// extracted by mini-css-extract-plugin
export var arrowMenu = "menu-module--arrowMenu--fdc32";
export var bold = "menu-module--bold--ab499";
export var country = "menu-module--country--ef42b";
export var flags = "menu-module--flags--03397";
export var subMenu = "menu-module--subMenu--9e340";
export var wrapper = "menu-module--wrapper--9825e";